import { Injectable } from '@angular/core';

import { Observable, BehaviorSubject } from 'rxjs';
import { map, tap, filter } from 'rxjs/operators';

import { VersionService } from './version.service';

interface IFeatures {
    [key: string]: any;
}

@Injectable()
export class FeaturesService {

    _dataSbj: BehaviorSubject<IFeatures> = new BehaviorSubject({}); 
    data$: Observable<IFeatures> = this._dataSbj.asObservable();

    get data() {
        return this._dataSbj.getValue();
    }

    constructor(
        private _versionSrv: VersionService
    ) {
        this._versionSrv.data$
            .pipe(filter((data) => !!data))
            .pipe(map(({ serverData: { features } }): IFeatures => {
                const response = features.reduce((acc, feature) => {
                    acc[feature.name] = feature;

                    return acc;
                }, {});

                return response;
            }))
            .pipe(tap((features) => {
                this._dataSbj.next(features)
            }))
            .subscribe();
    }

}
